import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-programmazione-droni',
  templateUrl: './programmazione-droni.component.html',
  styleUrls: ['./programmazione-droni.component.scss'],
})
export class ProgrammazioneDroniComponent implements OnInit {
  modulesText = {
    text: 'Grazie al drone Tello potrai imparare nozioni di fisica, robotica e ingegneria migliorando le tue capacità di programmazione e utilizzando al massimo la tua creatività e la tua immaginazione!',
  };

  constructor() {}

  ngOnInit(): void {}
}
